var _path;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.009 7.8C3.743 5.233 7.595 1.5 13 1.5s9.258 3.732 10.991 6.3c.278.412.259.941-.045 1.324C22.194 11.33 18.369 14.5 13 14.5c-5.37 0-9.194-3.17-10.946-5.376A1.11 1.11 0 0 1 2.009 7.8M13 .5C7.118.5 3.001 4.543 1.18 7.241a2.11 2.11 0 0 0 .09 2.505C3.139 12.098 7.225 15.5 13 15.5s9.862-3.402 11.73-5.754c.579-.73.607-1.738.09-2.505C22.999 4.543 18.882.5 13 .5M17.217 8c0 2.17-1.847 4-4.217 4s-4.217-1.83-4.217-4S10.63 4 13 4s4.217 1.83 4.217 4m1 0c0 2.761-2.335 5-5.217 5s-5.217-2.239-5.217-5S10.119 3 13 3c2.882 0 5.217 2.239 5.217 5",
    clipRule: "evenodd"
  })));
};
export default SvgEye;